import {Translation} from './translation';

export interface BotatoBaseConfig {
    translations: Translation[];
    // Every consumer has to set it; BotatoAngularLibBaseModule throws when it is missing.
    defaultLanguage?: string;
}

export const botatoBaseConfig: BotatoBaseConfig = {
    translations: [
        {
            language: 'de',
            translations: {
                'CHARACTER_INDICATOR': '{{length}} / {{maxLength}} Zeichen',
                'NO_CONNECTION_ERROR': 'Verbindungsproblem: Versuche Verbindung zum Server aufzubauen...',
                'ITEM_LIST_CHOOSE': 'Auswählen',
                'PLACEHOLDER': 'Nachricht eingeben...',
                'ATTACHMENT_ADD': 'Datei anhängen',
                'ATTACHMENT_REMOVE': 'Anhang entfernen',
                'ATTACHMENT_INVALID': 'Datei wird nicht unterstützt oder ist zu gross',
                'THINKING_INDICATOR': 'Denkt nach...',
                'NEW_MESSAGES': 'Neue Nachrichten',
                'FILE_UPLOAD': {
                    'TITLE_ERROR_MULTIPLE': 'Dateien konnten nicht geladen werden:',
                    'TITLE_ERROR_SINGLE': 'Datei konnte nicht geladen werden:',
                    'FILE_ERROR_SIZE': 'Datei zu gross',
                    'FILE_ERROR_TYPE': 'Falsches Dateiformat',
                    'FILE_ERROR_UNKNOWN': 'Unbekannter Fehler'
                },
                'AUTOCOMPLETE': {
                    'HINT_NO_ENTRIES': 'Keine Suchresultate'
                }
            }
        },
        {
            language: 'en',
            translations: {
                'CHARACTER_INDICATOR': '{{length}} / {{maxLength}} Signs',
                'NO_CONNECTION_ERROR': 'Connection problem: Trying to connect to the server...',
                'ITEM_LIST_CHOOSE': 'Select',
                'PLACEHOLDER': 'Enter message...',
                'ATTACHMENT_ADD': 'Attach file',
                'ATTACHMENT_REMOVE': 'Remove attachment',
                'ATTACHMENT_INVALID': 'File is not supported or too large',
                'THINKING_INDICATOR': 'Thinking...',
                'NEW_MESSAGES': 'New messages',
                'FILE_UPLOAD': {
                    'TITLE_ERROR_MULTIPLE': 'Files could not be loaded:',
                    'TITLE_ERROR_SINGLE': 'File could not be loaded:',
                    'FILE_ERROR_SIZE': 'File too big',
                    'FILE_ERROR_TYPE': 'Incorrect file format',
                    'FILE_ERROR_UNKNOWN': 'Unknown error'
                },
                'AUTOCOMPLETE': {
                    'HINT_NO_ENTRIES': 'No search results'
                }
            }
        },
        {
            language: 'fr',
            translations: {
                'CHARACTER_INDICATOR': '{{length}} / {{maxLength}} Signe',
                'NO_CONNECTION_ERROR': 'Problèmes de connexion : tentatives de connexion au serveur...',
                'ITEM_LIST_CHOOSE': 'Choisir',
                'PLACEHOLDER': 'Veuillez entrer le texte...',
                'ATTACHMENT_ADD': 'Joindre un fichier',
                'ATTACHMENT_REMOVE': 'Supprimer la pièce jointe',
                'ATTACHMENT_INVALID': 'Fichier non pris en charge ou trop volumineux',
                'THINKING_INDICATOR': 'En train de réfléchir...',
                'NEW_MESSAGES': 'Nouveaux messages',
                'FILE_UPLOAD': {
                    'TITLE_ERROR_MULTIPLE': 'Les fichiers n\'ont pas pu être chargés :',
                    'TITLE_ERROR_SINGLE': 'Le fichier n\'a pas pu être chargé :',
                    'FILE_ERROR_SIZE': 'Fichier trop gros',
                    'FILE_ERROR_TYPE': 'Format de fichier incorrect',
                    'FILE_ERROR_UNKNOWN': 'Erreur inconnue'
                },
                'AUTOCOMPLETE': {
                    'HINT_NO_ENTRIES': 'Aucun résultat'
                }
            }
        }],

    defaultLanguage: undefined
};
